<template>
  <v-btn icon @click="signOut">
    <v-icon right>mdi-logout</v-icon>
  </v-btn>
</template>

<script>
import { LOGOUT, MODULE_NAME as AUTH_MODULE } from '../store/types'

export default {
  name: 'LogoutButton.vue',
  methods: {
    signOut() {
      this.$store.dispatch(`${AUTH_MODULE}/${LOGOUT}`).then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style scoped></style>
